import React from "react";
import { Link } from "react-router-dom";
import './EventsContent.css'

const EventsContent = () => {

    const EventsList = [
        { img: '/Assets/Events/event4.jpg', title: 'Biz Bash Event', location: 'Goa', link: '/events/biz-bash-event-goa/' },
        { img: '/Assets/Events/event3.jpg', title: 'Achievers Mega Event', location: 'Mumbai', link: '/events/achievers-mega-event-mumbai/' },
        { img: '/Assets/Events/event2.jpg', title: 'Achievers Mega Event', location: 'Goa', link: '/events/achievers-mega-event-goa/' },
        { img: '/Assets/Events/event1.jpg', title: 'Achievers Mega Event', location: 'Lonavala', link: '/events/achievers-mega-event-lonavala/' },
    ]

    return (
        <>
            <div className="eventsList_container">
                <div className="pg_content_warpper">
                    <div className="Page-Main_Dec">
                        <h1 className="Page-title_LowerCase">Events</h1>
                    </div>
                    <div className="events_pg_cards">
                        {EventsList.map((event, index) => (
                            <>
                                <div className="event_card" key={index} id={`event_card${index}`}>
                                    <div className="eventCard_left">
                                        <img src={event.img} />
                                    </div>
                                    <div className="eventCard_right">
                                        <h2 className="eventCard_title">{event.title}</h2>
                                        <h3 className="eventCard_location">{event.location}</h3>
                                        <Link to={`${event.link}`} className="eventCard_link">View Photos</Link>
                                    </div>
                                </div>
                                {index !== EventsList.length - 1 && (
                                    <div style={{ borderTop: "1px solid #ccc" }}></div>
                                )}
                            </>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default EventsContent;